export default [
	{
		path: '/indicator/bloodPressure',
		name: 'IndicatorBloodPressure',
		component: () => import('@/views/indicator/blood-pressure.vue'),
		meta: { title: '血压记录' }
	},
	{
		path: '/indicator/bloodPressure/edit/:id?',
		name: 'IndicatorBloodPressureEdit',
		component: () => import('@/views/indicator/blood-pressure-edit.vue'),
		meta: { title: '血压记录' }
	},
	{
		path: '/indicator/bloodPressure/hostory/list',
		name: 'IndicatorBloodPressureHistory',
		component: () => import('@/views/indicator/blood-pressure-list.vue'),
		meta: { title: '血压记录' }
	},
	{
		path: '/indicator/bloodSugar',
		name: 'IndicatorBloodSugar',
		component: () => import('@/views/indicator/blood-sugar.vue'),
		meta: { title: '血糖记录' }
	},
	{
		path: '/indicator/bloodSugar/edit/:id?',
		name: 'IndicatorBloodSugarEdit',
		component: () => import('@/views/indicator/blood-sugar-edit.vue'),
		meta: { title: '血糖记录' }
	},
	{
		path: '/indicator/bloodSugar/list',
		name: 'IndicatorBloodSugarList',
		component: () => import('@/views/indicator/blood-sugar-list.vue'),
		meta: { title: '血糖记录' }
	},
	{
		path: '/indicator/bloodFat',
		name: 'IndicatorBloodFat',
		component: () => import('@/views/indicator/blood-fat.vue'),
		meta: { title: '血脂记录' }
	},
	{
		path: '/indicator/bloodFat/edit/:id?',
		name: 'IndicatorBloodFatEdit',
		component: () => import('@/views/indicator/blood-fat-edit.vue'),
		meta: { title: '血脂记录' }
	},
	{
		path: '/indicator/bloodFat/list',
		name: 'IndicatorBloodFatList',
		component: () => import('@/views/indicator/blood-fat-list.vue'),
		meta: { title: '血脂记录' }
	}
]
